module.exports = __webpack_public_path__ + "static/media/PenguinSkipTeaser.42562a0c.jpg";